import StationAPI from '../api/station'
import StatiscticsAPI from '../api/statistics'
import object from 'lodash/object'

const CREATING_STATION = 'CREATING_STATION'
const CREATING_STATION_SUCCESS = 'CREATING_STATION_SUCCESS'
const CREATING_STATION_ERROR = 'CREATING_STATION_ERROR'
const FETCHING_STATIONS = 'FETCHING_STATIONS'
const FETCHING_STATIONS_SUCCESS = 'FETCHING_STATIONS_SUCCESS'
const FETCHING_STATIONS_ERROR = 'FETCHING_STATIONS_ERROR'
const FETCHING_STATION = 'FETCHING_STATION'
const FETCHING_STATION_SUCCESS = 'FETCHING_STATION_SUCCESS'
const FETCHING_STATION_ERROR = 'FETCHING_STATION_ERROR'
const UNSET_STATION = 'UNSET_STATION'
const SET_DEVICES = 'SET_DEVICES'
const FETCH_LAST_DATA = 'FETCH_LAST_DATA'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    stations: [],
    currentStation: null,
    devices: [],
    currentStationError: null,
    currentStationLoading: false,
    lastData: null
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    hasError (state) {
      return state.error !== null
    },
    error (state) {
      return state.error
    },
    hasStations (state) {
      return state.stations.length > 0
    },
    stations (state) {
      return state.stations
    },
    hasStation (state) {
      return state.currentStation !== null
    },
    station (state) {
      return state.currentStation
    },
    devices (state) {
      return state.devices
    },
    lastData (state) {
      return state.lastData
    }
  },
  mutations: {
    [CREATING_STATION] (state) {
      state.isLoading = true
      state.error = null
    },
    [CREATING_STATION_SUCCESS] (state, station) {
      state.isLoading = false
      state.error = null
      state.stations.unshift(station)
    },
    [CREATING_STATION_ERROR] (state, error) {
      state.isLoading = false
      state.error = error
      state.stations = []
    },
    [FETCHING_STATIONS] (state) {
      state.isLoading = true
      state.error = null
      state.stations = []
    },
    [FETCHING_STATIONS_SUCCESS] (state, stations) {
      state.isLoading = false
      state.error = null
      state.stations = stations
    },
    [FETCHING_STATIONS_ERROR] (state, error) {
      state.isLoading = false
      state.error = error
      state.stations = []
    },
    [FETCHING_STATION] (state) {
      state.currentStationLoading = true
      state.currentStationError = null
      state.currentStation = null
    },
    [FETCHING_STATION_SUCCESS] (state, station) {
      state.currentStationLoading = false
      state.currentStationError = null
      state.currentStation = station
    },
    [FETCHING_STATION_ERROR] (state, error) {
      state.currentStationLoading = false
      state.currentStationError = error
      state.currentStation = null
    },
    [UNSET_STATION] (state) {
      state.currentStation = null
    },
    [SET_DEVICES] (state, devices) {
      state.devices = devices
    },
    [FETCH_LAST_DATA] (state, data) {
      state.lastData = data
    }
  },
  actions: {
    async create ({ commit }, data) {
      commit(CREATING_STATION)
      try {
        let response = await StationAPI.create(data)
        commit(CREATING_STATION_SUCCESS, response.data)
        return response.data
      } catch (error) {
        commit(CREATING_STATION_ERROR, error)
        return null
      }
    },
    async loadLastData ({ commit }, id) {
      try {
        let response = await StationAPI.lastData(id)
        commit(FETCH_LAST_DATA, response.data)
        return response.data
      } catch (error) {
        return null
      }
    },
    async findAll ({ commit }) {
      commit(FETCHING_STATIONS)
      try {
        let response = await StationAPI.findAll()
        commit(FETCHING_STATIONS_SUCCESS, response.data)
        return response.data
      } catch (error) {
        commit(FETCHING_STATIONS_ERROR, error)
        return null
      }
    },
    async findOne ({ commit }, id) {
      commit(FETCHING_STATION)
      try {
        const response = await StationAPI.findOne(id)
        const configuredDevices = await StatiscticsAPI.fetchDevices(id)

        commit(FETCHING_STATION_SUCCESS, response.data)
        commit(SET_DEVICES, object.values(configuredDevices.data).flat())
        return response.data
      } catch (e) {
        commit(FETCHING_STATION_ERROR, e)
        return null
      }
    },
    unsetCurrent ({ commit }) {
      commit(UNSET_STATION)
    }
  }
}
